import moment from 'moment';
import format from "number-format.js"


const formatValue = (value, type, mask, ignoreTimezoneConversion) => {
    const user = JSON.parse(sessionStorage.getItem('user')) || {};
    if (!user.system) {
        user.system = {}
    }
    const {
        system: {
            //thousandSeparator = ',',
            //decimalSeparator = '.',
            timeFormat = 'hh:mm:ss.sss',
            dateFormat = 'YYYY MM DD',
            dateTimeFormat = 'YYYY MM DD hh:mm:ss',
            useTimeZone = 'UTC'
        }
    } = user;
    const numberMask = mask ? mask : '#,##0.#0';
    const intMask = mask ? mask : '#,##0.';
    //do not format grandTotal cell
    if (value === 'Grand Total') {
        return value
    }
    switch (type) {
        case 'number':
            return format(numberMask, value);
        case 'integer':
            return format(intMask, value);
        case 'date':
            return value ? moment(value).utcOffset(useTimeZone).format(mask ? mask : dateFormat) : "";
        case 'time':
            return moment(value, "HH:mm:ss")
                .add(ignoreTimezoneConversion ? 0 : parseInt(useTimeZone || "0"), 'hours')
                .format(mask ? mask : timeFormat);
        case 'datetime':
            return value ? moment(value).utcOffset(ignoreTimezoneConversion ? "UTC" : useTimeZone).format(mask ? mask : dateTimeFormat) : ""
        case 'bool':
            return value === undefined ? '' : value === false ? 'false' : 'true';
        case 'duration':
            return value ? transformDuration(value, mask) : "";
        case 'entityExternal':
            return value ? transformEntityExternal(value) : "";
        default:
            return defaultValue(value)
    }
};

function transformDuration(value = "", mask = "") {
    //split value
    let splitValue = value && value.toString().split(':');
    let splitSsMs = splitValue[2] ? splitValue[2].split('.') : [];

    //split mask
    let splitMask = mask.split(':');
    let splitMaskSsMs = splitMask[2] ? splitMask[2].split('.') : [];
    let isHH = splitMask[0] === 'HH';
    let isMM = splitMask[1] === 'MM';
    let isSS = splitMaskSsMs[0] === 'SS';
    let isSSS = splitMaskSsMs[1] === 'sss';

    let HH = splitValue[0];
    let MM = splitValue[1];
    let SS = splitSsMs[0];

    if (isHH && isMM && isSS && isSSS) {
        return value
    } else if (isHH && !isMM) {
        return HH
    } else if (isHH && isMM && !isSS) {
        return HH + ':' + MM
    } else if (isHH && isMM && isSS && !isSSS) {
        return HH + ':' + MM + ':' + SS
    } else {
        return value
    }
}

function transformEntityExternal(value) {
    if (value instanceof Array) {
        return value.join(', ')
    } else if (value instanceof Object) {
        return value.hasOwnProperty('id') ? value.id : 'object value'
    }
    return value
}

function defaultValue(value) {
    if (typeof value === 'object') {
        //return 'object value'
        return 'object value'
    } else {
        return value
    }
}

export default formatValue;